import { Divider, Grid, Stack, Typography } from "@mui/material";
import { BtnBack, BtnDownload, BtnDuplicate, BtnSave } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import moment from "moment";
import { FormProvider, useForm } from "react-hook-form";
import { Extension, FnAxios, FnDialog, I18n } from "utilities/utilities";
import UploadFile from 'components/Input/UploadFile';
import { useEffect, useRef, useState } from "react";
import { PaginationInterface, initRows } from 'components/DataGrid'
import { BtnMenuAddOnTable } from "components/Button/ButtonTable";
import AutoCompleteInTable from "components/DataGrid/AutoCompleteInTable";
import { IIndicatorDataRow } from "./IIndicatorInterface";
import { useLocation, useNavigate } from "react-router";
import SwitchFormItem from "components/Input/Switch";
import { TextAreaItem } from "components/Input/TextArea";
import { GetMenuPermission } from "utilities/SystemFunction";
import UploadFileItem from "components/Input/UploadFile";
import STTable from "components/STTable";
import { STTableColumnDetail } from "components/STTable/STTableProps";

const IndicatorForm = () => {
    const navigate = useNavigate();
    const AxiosFn = FnAxios();
    const DialogFn = FnDialog();
    const handleClearAttachFile = useRef(null);
    const handleClearExcelFile = useRef(null);
    const location = useLocation();
    const searchParams = location.search;
    const sRequestID = new URLSearchParams(searchParams).get('sID');
    const nYear = new URLSearchParams(searchParams).get('nYear');
    const [arrImportExcel, setarrImportExcel] = useState([])
    const [arrImport, setarrImport] = useState([])
    const [loadingTable, setLoadingTable] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [nOrderNumber, setOrderNumber] = useState(0);
    const [nItemRowId, setItemRowId] = useState("");
    const [isPermission, setPermission] = useState<boolean>(false);
    const [isEdit, setEdit] = useState(false);
    const [isImport, setIsImport] = useState(false);
    const [arrDataOrder, setArrDataOrder] = useState([]);
    const [sValueItem, setValueItem] = useState(null);
    const [arrAddTableMenu, setArrAddTableMenu] = useState([]);
    const [dataRow, setDataRow] = useState<PaginationInterface>({
        ...initRows,
        sSortExpression: "nOrder",
        sSortDirection: "asc"

    });
    const form = useForm({
        shouldFocusError: true,
        mode: "all"
    });

   


    const dDateNow = Date.now();

    //menu for AddTable
    const TableMenu = (sID) => {
        let param = {
            nIndicatorID: +(sID)
        }

        AxiosFn.Post(`Indicator/OnCheckCanDeleteDetail`, param, (result) => {
            if (result.objResult.isDelete) {
                setArrAddTableMenu([
                    {
                        value: '1',
                        Label: "เพิ่มแถวบน",
                    },
                    {
                        value: '2',
                        Label: "เพิ่มแถวล่าง",
                    },
                    {
                        value: '3',
                        Label: "เพิ่มรายการย่อย",
                    },
                    {
                        value: '4',
                        Label: "ลบ",
                    }
                ]);
            } else {
                setArrAddTableMenu([
                    {
                        value: '1',
                        Label: "เพิ่มแถวบน",
                    },
                    {
                        value: '2',
                        Label: "เพิ่มแถวล่าง",
                    },
                    {
                        value: '3',
                        Label: "เพิ่มรายการย่อย",
                    }
                ]);
            }
        });
    }

    const getFormInitial = () => {
        AxiosFn.Post(`Indicator/GetFormInitial`, { sFormID: sRequestID }, (result) => {
            form.setValue("dYearPickerSearch", result.objResult.obiInitial.sYear);
            form.setValue("statusIndicator", result.objResult.obiInitial.isActive);
        });
    }

    const getTable = (p: PaginationInterface) => {
        setLoadingTable(true);

        let param = {
            ...p,
            nYearNow: dDateNow.valueOf(),
            nYear: nYear,
            sFormID: sRequestID,
            nPageSize: 5000
        }

        AxiosFn.Post(`Indicator/GetTableIndicatorDetail`, param, (result) => {
            setLoadingTable(false);
            setarrImport([...result.objResult.lstFile]);
            setDataRow({
                ...p,
                arrRows: result.lstDataIndicatorDetail,
                nDataLength: result.ObjTable?.nDataLength,
                nPageIndex: result.ObjTable?.nPageIndex,
            });
            
            let arrResult = [];
            arrResult = result.lstDataIndicatorDetail

            arrResult.forEach(f => {
                setTimeout(() => {
                    form.setValue(`sTextArea_${f.sID}`, f.sIndicatorName);
                }, 200);

            });
        });
    };

    const handleAddItem = (value, sID, nOrderNumber) => {
        setValueItem(value);

        if (value !== '4') {
            let param = {
                sValue: value,
                sID: sID,
                nOrderNumber: nOrderNumber,
                sFormID: sRequestID,
                lstDataRow: dataRow.arrRows
            }

            AxiosFn.Post(`Indicator/OnAddItem`, param, (result) => {
                let arrResult = [];
                arrResult = result.objResult.lstDataRow
                arrResult.forEach(f => {
                    setTimeout(() => {
                        form.setValue(`sTextArea_${f.sID}`, f.sIndicatorName);
                    }, 200);
                });

                getDataRow(arrResult);

                let isExpand: any = document.getElementById("BtnExpand")
                if (isExpand) { isExpand.value = sID }
                document.getElementById("BtnExpand").click();

                setDataRow({
                    ...dataRow,
                    arrRows: arrResult// result.objResult.lstDataRow
                });
            }, (err) => {
                if (err.nStatusCode === 409) {
                    DialogFn.Warning(err.Message);
                } else {
                    DialogFn.Warning(err.Message);
                }
            });
        } else {
            handleDelete(sID);
        }
    }

    const handleDelete = (sID: string) => {
        DialogFn.Submit("คุณต้องการลบข้อมูลใช่หรือไม่ ?", () => {
            let arrAll = dataRow.arrRows.filter((f) => !sID.includes(f.sID));
            let arrCloneParent = dataRow.arrRows.filter((f) => f.isCollapseChild);
            let arrCloneChild = dataRow.arrRows.filter((f) => f.nParentID != null && f.isCollapseHead && !sID.includes(f.sID));

            let arrClone = dataRow;
            let result = arrClone.arrRows.filter((f) => !sID.includes(f.sID));
            let arrDelete = arrClone.arrRows.filter((f) => f.sID === sID);
            if (arrDelete.length > 0) {
                arrDelete.forEach((f) => {
                    f.isDelete = true //tag delete status and send to real delete at backend

                    if (f.isDelete) {
                        arrCloneParent.forEach(item => {
                            if (f.nID === item.nParentID) {
                                item.isDelete = true

                                if (item.isDelete) {
                                    arrCloneChild.forEach(child => {
                                        if (item.nID === child.nParentID) {
                                            child.isDelete = true
                                        }
                                    });
                                }
                            }
                        });
                    }
                });
            }

            arrDelete = arrDelete.filter((f) => f.sID === sID);
            let lstExcludeDelete = arrAll.filter(f => !f.isDelete);
            arrDelete.forEach(f => {
                lstExcludeDelete.forEach(item => {
                    if (item.nLevelID === 0) {
                        if (f.nOrder < item.nOrder && f.nLevelID === 0) {
                            item.nOrder = --item.nOrder;
                            item.sOrder = item.nOrder + "";
                        }

                        lstExcludeDelete.forEach(child => {
                            if (item.nID === child.nParentID && child.nLevelID !== 0) {
                                let lstOrder = child.sOrder.split(".");

                                child.sOrder = lstOrder.length === 2 ? item.sOrder + "." + lstOrder[1] :
                                    lstOrder.length === 3 ? item.sOrder + "." + lstOrder[1] + "." + lstOrder[2] :
                                        lstOrder.length === 4 ? item.sOrder + "." + lstOrder[1] + "." + lstOrder[2] + "." + lstOrder[3] :
                                            null;
                            }
                        });
                    } else if (item.nLevelID === 1) {
                        if (f.nOrder < item.nOrder && f.nLevelID === 1) {
                            let lstOrder = item.sOrder.split(".");
                            item.nOrder = lstOrder.length === 2 ? lstOrder[0] + "." + --lstOrder[1] : null
                            item.sOrder = item.nOrder + "";
                        }

                        lstExcludeDelete.forEach(child => {
                            if (item.nID === child.nParentID && child.nLevelID === 2) {
                                let lstOrder = child.sOrder.split(".");
                                child.sOrder = lstOrder.length === 2 ? item.sOrder + "." + lstOrder[1] :
                                    lstOrder.length === 3 ? item.sOrder + "." + lstOrder[2] :
                                        lstOrder.length === 4 ? item.sOrder + "." + lstOrder[3] :
                                            null;
                            }
                        });
                    } else if (item.nLevelID === 2) {
                        if (f.nOrder < item.nOrder && f.nLevelID === 2) {
                            let lstOrder = item.sOrder.split(".");
                            item.nOrder = lstOrder.length === 3 ? lstOrder[0] + "." + lstOrder[1] + "." + --lstOrder[2] : null

                            item.sOrder = item.nOrder + "";
                        }

                        lstExcludeDelete.forEach(child => {
                            if (item.nID === child.nParentID && child.nLevelID === 3) {
                                let lstOrder = child.sOrder.split(".");

                                child.sOrder = lstOrder.length === 2 ? item.sOrder + "." + lstOrder[1] :
                                    lstOrder.length === 3 ? item.sOrder + "." + lstOrder[2] :
                                        lstOrder.length === 4 ? item.sOrder + "." + lstOrder[3] :
                                            null;
                            }
                        });
                    } else if (item.nLevelID === 3) {
                        if (f.nOrder < item.nOrder && f.nLevelID === 3) {
                            let lstOrder = item.sOrder.split(".");
                            item.nOrder = lstOrder.length === 4 ? lstOrder[0] + "." + lstOrder[1] + "." + lstOrder[2] + "." + --lstOrder[2] : null

                            item.sOrder = item.nOrder + "";
                        }

                        lstExcludeDelete.forEach(child => {
                            if (item.nID === child.nParentID && child.nLevelID !== 0) {
                                let lstOrder = child.sOrder.split(".");

                                child.sOrder = lstOrder.length === 2 ? item.sOrder + "." + lstOrder[1] :
                                    lstOrder.length === 3 ? item.sOrder + "." + lstOrder[1] + "." + lstOrder[2] :
                                        lstOrder.length === 4 ? item.sOrder + "." + lstOrder[1] + "." + lstOrder[2] + "." + lstOrder[3] :
                                            null;
                            }
                        });
                    }
                });
            });

            if (arrCloneChild.length > 0) {
                arrCloneParent.forEach(parent => {
                    parent.isCollapseChild = false

                    arrCloneChild.forEach(child => {
                        if (child.nParentID === parent.nID) {
                            parent.isCollapseChild = true
                        }
                    });
                });
            } else {
                arrCloneParent.forEach(parent => {
                    parent.isCollapseChild = false
                });
            }

            setDataRow({
                ...arrClone,
                arrRows: [...result.filter(f => !f.isDelete)],
                nDataLength: result.filter(f => !f.isDelete).length,
            });

            DialogFn.Success("ลบสำเร็จ", () => {
            });
        });
    }

    const handleImportExcel = (p: PaginationInterface) => {
        setLoadingTable(true);
        let param = {
            ...p,
            lstFileUpload: arrImportExcel || []
        }

        AxiosFn.Post(`Indicator/OnImportExcel`, param, (result) => {
            if (result.nStatusCode == 200) {
                form.setValue("dYearPickerSearch", result.objResult.sYear);
                setIsImport(true);
                setDataRow({
                    ...p,
                    arrRows: result.objResult.lstIndicatorDetail,
                });

                //set indicator name
                let arrResult = [];
                arrResult = result.objResult.lstIndicatorDetail

                arrResult.forEach(f => {
                    form.setValue(`sTextArea_${f.sID}`, f.sIndicatorName);
                });
                setLoadingTable(false);
            }
        }, (err) => {
            if (err.nStatusCode === 409) {
                DialogFn.Warning(err.Message);
                setarrImportExcel([]);
            } else {
                DialogFn.Warning(err.Message);
                setarrImportExcel([]);
            }

            handleClearExcelFile.current();
        });
    }

    const handleSubmit = (e, nMode) => {
        // nMode:
        // 1 = save
        // 2 = duplicate

        let array = [];
        array = dataRow.arrRows;

        array.forEach(f => {
            let arrDataRow = {} as IIndicatorDataRow;

            arrDataRow.sID = f.sID;
            arrDataRow.nID = +(f.sID);
            arrDataRow.sIndicatorName = e[`sTextArea_${f.sID}`];
            f.sIndicatorName = e[`sTextArea_${f.sID}`] || f.sIndicatorName;
        });

        let param = {
            nYear: moment(form.getValues("dYearPickerSearch")).valueOf(),
            isStatus: e["statusIndicator"],
            lstNewDataRow: array,
            lstFile: arrImport || [],
            sLocation: location.pathname,
            nMode: nMode,
            isImport: isImport
        }

        DialogFn.Submit("คุณต้องการบันทึกข้อมูลใช่หรือไม่ ?", () => {
            AxiosFn.Post(`Indicator/OnSubmit`, param, (result) => {
                if (result.nStatusCode === 200) {
                    DialogFn.Success("บันทึกสำเร็จ", () => {
                        navigate("/indicator");
                    });
                }
            }, (err) => {
                DialogFn.Warning(err.Message);
            });
        });
    }

    const handleExportExcel = () => {
        let sFileName = `ตัวชี้วัดกรมบัญชีกลาง(รายปี)_Template.xlsx`
        let param = {
            nYear: moment(form.getValues("dYearPickerSearch")).valueOf(),
            lstDataRow: dataRow.arrRows,
        }

        AxiosFn.DowloadFileBlob(`Indicator/OnExportExcel`, param, sFileName, (result) => {
            DialogFn.UnBlockUI();
        });
    }

    const handleCheckYearAvilable = (e) => {
        let param = {
            nChooseDate: form.getValues("dYearPickerSearch").valueOf()
        }

        AxiosFn.Post(`Indicator/OnCheckYearAvilable`, param, (result) => { }, (err) => {
            DialogFn.UnBlockUI();
            if (err.nStatusCode === 409) {
                form.reset();
                form.clearErrors();

                DialogFn.Warning("ปีนี้ถูกเลือกแล้ว กรุณาเลือกปีอื่น");
            } else if (!err.response) {
                DialogFn.Warning(err.sMessage);
                form.reset();
                form.clearErrors();
            }
        });
    }

    const getDataRow = (arrResult?: any) => {
        let param = {
            nYearNow: dDateNow.valueOf(),
            nYear: nYear,
            sFormID: sRequestID,
            lstDataRow: dataRow.arrRows,
            nPageSize: 5000
        }

        AxiosFn.Post(`Indicator/GetTableIndicatorDetail`, param, (result) => {
            let arrOrder = result.lstDataIndicatorDetail;

            dataRow.arrRows.forEach(row => {
                arrOrder = arrOrder.filter(f => f.nParentID === row.nParentID && f.nLevelID === row.nLevelID);
            });
            setArrDataOrder(arrOrder);

            arrOrder.forEach(f => {
                form.setValue(`sTextArea_${f.sID}`, f.sIndicatorName);
            });
            // if (rowNode.type === 'group') {
            //     setTimeout(() => {
            //         apiRef.current.setRowChildrenExpansion(rowNode.id, !rowNode.childrenExpanded);
            //         setExpand((prev) => !prev);
            //     }, 200);
            // }
        });
    }

    const handleChange = (sID, sOrderNumber, arrDataRow) => {
        let arrData = arrDataRow.length == 0 ? dataRow.arrRows : arrDataRow;

        // sOrderNumber = order number ที่ต้องการเปลี่ยน
        let param = {
            sID: sID,
            sOrder: sOrderNumber,
            lstDataRow: arrData
        }

        AxiosFn.Post(`Indicator/OnChange`, param, (result) => {
            setDataRow({
                ...dataRow,
                arrRows: result.objResult.lstChangeOrder,
            });

            dataRow.arrRows.forEach(f => {
                result.objResult.lstChangeOrder.forEach(item => {
                    if (f.sID === item.sID) {
                        setTimeout(() => {
                            form.setValue(`sLastUpdate`, f.sLastUpdate);
                            // form.setValue(`sIndicatorName`, f.sIndicatorName);
                        }, 200);
                    }
                });
            })
        });
    }

    useEffect(() => {
        GetMenuPermission(AxiosFn, setPermission, DialogFn);

        getFormInitial();
        if (arrImportExcel[0] != null && arrImportExcel[0] != undefined) {
            handleImportExcel(dataRow);
        } else if (arrImportExcel[0] == undefined) {
            getTable(dataRow);
        } else {
            getTable(dataRow);
        }

        if (sRequestID !== null) {
            setEdit(true);
        }
    }, [arrImportExcel]);

    useEffect(() => {
        getDataRow();
    }, [sValueItem]);

    // #region column
    const CollapseColumn: STTableColumnDetail = {
        field: `elCollapse`,
        headerName: '',
        bodyAlign: "center",
        width: "15%",
        sortable: false,
        isSort: false,
        collapse: true,
        getAction: (item) => {
            const lstDataOrder = [];
            dataRow.arrRows.forEach((e, index) => {
                if (item.nParentID === e.nParentID && item.nLevelID === e.nLevelID) {
                    lstDataOrder.push({
                        label: e.sOrder,
                        value: e.sOrder,
                    });
                }
            });
            return [
                <AutoCompleteInTable
                    small
                    fullWidth
                    objValue={{
                        label: item.sOrder,
                        value: item.sOrder
                    }}
                    funcOnChange={(newValue: any) => {
                        handleChange(item.sID, newValue.target.innerText, arrDataOrder)
                    }}
                    lstOption={lstDataOrder}
                    disClearable
                    sxCustom={{ width: "211%" }}
                    disabled={!isPermission }
                />
            ]
        }
    };

    const ButtonColumn: STTableColumnDetail = {
        field: 'ปุ่ม (เพิ่ม/แก้ไข)',
        headerName: '',
        headerAlign: 'center',
        bodyAlign: 'center',
        width: "5%",
        sortable: false,
        isSort: false,
        collapse: false,
        getAction: (item) => {
            return [
                <BtnMenuAddOnTable
                    key={item.sID}
                    id={"BtnExpand"}
                    onClick={(event) => {
                        setAnchorEl(event.currentTarget);
                        setItemRowId(item.sID);
                        setOrderNumber(item.nOrder);
                        TableMenu(item.sID);
                    }}
                    handleAddItem={handleAddItem}
                    arrTableMenu={arrAddTableMenu}
                    // arrTableMenu={arrAddTableMenu}
                    setAnchorEL={setAnchorEl}
                    anchorEL={anchorEl}
                    nItemRowId={nItemRowId}
                    nOrderNumber={nOrderNumber}
                    IsDisabled={!isPermission }
                />
            ]
        }
    };

    const sIndicatorNameColumn: STTableColumnDetail = {
        field: 'sIndicatorName',
        headerName: 'ตัวชี้วัด',
        headerAlign: 'center',
        bodyAlign: 'left',
        width: "70%",
        sortable: false,
        isSort: false,
        collapse: false,
        getAction(item) {
            let rows = dataRow.arrRows.filter(f => f.sID === item.sID)
            return [
                <FormProvider {...form}>
                    <Grid container>
                        <TextAreaItem
                            name={"sTextArea_" + item.sID}
                            maxLength={500}
                            row={1}
                            required={true}
                            style={{ marginTop: "1px", marginBottom: "1px" }}
                            IsShowMessageError={false}
                            onChange={(e) => {
                                rows.forEach(f => {
                                    if (f.sID === item.sID) {
                                        f.sIndicatorName = e.target.value;
                                    }
                                });
                            }}
                            disabled={!isPermission }
                        />
                    </Grid>
                </FormProvider>
            ]
        },
    };

    const sLastUpdateColumn: STTableColumnDetail = {
        field: 'sLastUpdate',
        headerName: 'แก้ไขล่าสุด',
        headerAlign: 'center',
        bodyAlign: 'center',
        width: "10%",
        sortable: false,
        isSort: false,
        collapse: false
    };
    // #endregion

    let dataColumnST = [] as STTableColumnDetail[];

    dataColumnST = [CollapseColumn, ButtonColumn, sIndicatorNameColumn, sLastUpdateColumn] as STTableColumnDetail[];

    return (
        <FormProvider {...form}>
            <Grid container spacing={2}>
                <Grid item md={2} xs={6}>
                    <DatePickerItem
                        name={`dYearPickerSearch`}
                        id={`dYearPickerSearch`}
                        label={I18n.SetText("exampleComponents.yearPicker")}
                        IsYearPicker
                        minDate={moment()}
                        required={true}
                        disabled={isEdit || !isPermission}
                        onChange={(e) => { if (e !== null) { handleCheckYearAvilable(e) } }}

                    />
                </Grid>

                <Grid item md={6} xs={6} sx={{ ml: "2%" }}>
                    <BtnDuplicate id={"btnDuplicate"} IsDisabled={!isPermission} onClick={form.handleSubmit((e) => { handleSubmit(e, 2) })} />
                </Grid>
            </Grid>

            <Grid item md={12} xs={12} sx={{ mt: "2%" }}>
                <Stack direction={"row"} spacing={2}>
                    {/* นำเข้าข้อมูล */}
                    <Typography>{I18n.SetText("indicatorPage.importData")}</Typography>
                    <BtnDownload id={"downloadTemplateIndicator"} IsDisabled={!isPermission} txt={I18n.SetText("indicatorPage.downloadTemplate")} onClick={() => { handleExportExcel() }} />
                </Stack>
            </Grid>

            <Divider sx={{ my: "1%" }} />

            <Grid item md={12} xs={12}>
                <UploadFile
                    id="sListFileSaveTable"
                    name={"sListFileSaveTable"}
                    label={""}
                    required={false}
                    arrFile={arrImportExcel}
                    setarrFile={setarrImportExcel}
                    sFolderTemp="FolderExample"
                    IsFolder={false}
                    IsMultiple={false}
                    Extension={[...Extension.Excel]}
                    nLimitFile={30}
                    sLimitFile={"MB"}
                    onClearFile={handleClearExcelFile}
                    sPositionText="right"
                    IsCrop={false}
                    cropMovable={false}
                    cropResize={false}
                    cropShape="retangle"
                    modeDisplay='list'
                    disabled={!isPermission }
                />
            </Grid>

            <Grid
                item
                xs={12}
                sx={{
                    marginTop: "5vh",
                    '& .super-app-theme--header': {
                        backgroundColor: 'rgba(255, 7, 0, 0.55)',
                    },
                }}
            >
                <STTable
                    column={dataColumnST}
                    rows={dataRow}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isShowCheckBox={false}
                    isHiddenPagination={true}//hide pagination
                />
            </Grid>

            <Grid item xs={12} sx={{ marginTop: "4%" }}>
                {/* เอกสารแนบ (บันทึกข้อตกลงการประเมิณผลการดำเนินงานทุนหมุนเวียนประจำปีบัญชี) */}
                <Typography>{I18n.SetText("indicatorPage.fileEvolution")}</Typography>
                <Divider />
                <UploadFileItem
                    id="sListFileSave"
                    name={"sListFileSave"}
                    label={""}
                    required={true}
                    arrFile={arrImport}
                    setarrFile={setarrImport}
                    sFolderTemp="IndicatorFile"
                    IsFolder={false}
                    IsMultiple={true}
                    Extension={[...Extension.ImageDocument]}
                    nLimitFile={30}
                    sLimitFile={"MB"}
                    onClearFile={handleClearAttachFile}
                    sPositionText="right"
                    IsCrop={false}
                    cropMovable={false}
                    cropResize={false}
                    cropShape="retangle"
                    modeDisplay='list'
                    disabled={!isPermission}
                   
                />
            </Grid>

            <Grid item xs={12} sx={{ marginTop: "4%" }}>
                <Typography>
                    {I18n.SetText("indicatorPage.status")}
                    <span style={{ color: "red" }}> * </span>
                </Typography>
                <Divider sx={{ mb: "2%" }} />
                <SwitchFormItem
                    id={'statusIndicator'}
                    name={"statusIndicator"}
                    disabled={!isPermission}
                   
                />
            </Grid>

            <Grid item xs={12} >
                {/* Button */}
                <Grid container spacing={2} justifyContent={"space-between"} alignItems={"start"} sx={{ display: "flex", my: "2%" }}>
                    <Grid item>
                        <BtnBack id={"btnBack"} onClick={() => { navigate("/indicator"); }} />
                    </Grid>
                    <Grid item>
                        <BtnSave id={"btnSave"} IsDisabled={!isPermission} onClick={form.handleSubmit((e) => handleSubmit(e, 1))} />
                    </Grid>
                </Grid>
            </Grid>
        </FormProvider>
    );
}

export default IndicatorForm;